import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
declare global {
  interface Window {
    fbq?: ((event: string, ...args: unknown[]) => void) & {
      queue?: unknown[][];
      loaded?: boolean;
      version?: string;
      callMethod?: (...args: unknown[]) => void;
    };
    _fbq?: unknown;
  }
}
const META_PIXEL_ID = '2758664024470345';
export function App() {
  useEffect(() => {
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          pixel.callMethod ? pixel.callMethod(...args) : pixel.queue?.push(args);
        } as NonNullable<Window['fbq']>;
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch {
      /* Analytics must not affect the storefront. */
    }
  }, []);
  return <div className="min-h-screen w-full bg-black text-white selection:bg-gold/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TestimonialsStrip data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionReveal data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <ExtendedTestimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchaseNotifications data-id="element-14" />
      <img src="https://www.facebook.com/tr?id=2758664024470345&ev=PageView&noscript=1" alt="" aria-hidden="true" width={1} height={1} className="hidden" data-id="element-15" />
    </div>;
}